import { render, staticRenderFns } from "./TheHeaderContent.vue?vue&type=template&id=dc3760d8"
import script from "./TheHeaderContent.vue?vue&type=script&lang=js"
export * from "./TheHeaderContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports